import { render, staticRenderFns } from "./emptyData.vue?vue&type=template&id=0d7ddbb0&scoped=true&"
import script from "./emptyData.vue?vue&type=script&lang=js&"
export * from "./emptyData.vue?vue&type=script&lang=js&"
import style0 from "./emptyData.vue?vue&type=style&index=0&id=0d7ddbb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7ddbb0",
  null
  
)

export default component.exports